/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateWorkspaceThemeDto { 
    theme: UpdateWorkspaceThemeDto.ThemeEnum;
}
export namespace UpdateWorkspaceThemeDto {
    export const ThemeEnum = {
        Romantic: 'romantic',
        Elegant: 'elegant',
        Minimal: 'minimal'
    } as const;
    export type ThemeEnum = typeof ThemeEnum[keyof typeof ThemeEnum];
}


